const state = {
  temporaryOutfits: []
};

const getters = {
  temporaryOutfits: ({ temporaryOutfits }) => {
    return temporaryOutfits;
  }
};

const actions = {
  async addTemporaryOutfit({ commit }, outfit) {
    commit('ADD_TEMPORARY_OUTFIT', outfit);
  }
}

const mutations = {
  'ADD_TEMPORARY_OUTFIT' (state, outfit) {
    state.temporaryOutfits.push(outfit);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/landing/index.js